export const LIVE_WIDGET_CATS = ['live_youtube', 'live_twitch', 'live_vimeo'];

export const isLiveWidget = (item) =>
  LIVE_WIDGET_CATS.includes(item?.widget?.widgetCat);

export const LIVE_QUALITIES = ['auto', '1080p', '720p', '480p', '360p'];
